import { useMemo } from "react";
import {
  MANAGED_VALIDATOR_THRESHOLD,
  SHARED_NODE_THRESHOLD,
} from "@/common/constants/validator-eligibility.constants";

function normalizeAvailableBalance(
  availableBalance: string | number | undefined,
) {
  if (typeof availableBalance === "string") {
    return Number(availableBalance.replace(/,/g, "").replace(/[^\d.]/g, ""));
  }
  return Number(availableBalance);
}

export interface UseValidatorEligibilityResult {
  normalizedBalance: number;
  managedEligible: boolean;
  sharedEligible: boolean;
  /** True if the user meets at least one path (managed validator or shared node). */
  isQualified: boolean;
  /** Alias for `isQualified`. */
  isEligible: boolean;
}

export function getValidatorEligibility(
  availableBalance?: string | number,
): UseValidatorEligibilityResult {
  const normalizedBalance = normalizeAvailableBalance(availableBalance);
  const managedEligible =
    Number.isFinite(normalizedBalance) &&
    normalizedBalance >= MANAGED_VALIDATOR_THRESHOLD;
  const sharedEligible =
    Number.isFinite(normalizedBalance) &&
    normalizedBalance >= SHARED_NODE_THRESHOLD;
  const isQualified = managedEligible || sharedEligible;

  return {
    normalizedBalance,
    managedEligible,
    sharedEligible,
    isQualified,
    isEligible: isQualified,
  };
}

export function useValidatorEligibility(
  availableBalance?: string | number,
): UseValidatorEligibilityResult {
  return useMemo(
    () => getValidatorEligibility(availableBalance),
    [availableBalance],
  );
}
